import * as React from "react";

function SvgKustomer(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 184.6 183.2"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          d="M61 120.4c-.9 0-1.7.5-2.2 1.2-.4.8-.4 1.7 0 2.5s11.5 19.5 33.5 19.5 33-18.7 33.5-19.5c.4-.8.4-1.7 0-2.5s-1.3-1.2-2.2-1.2H61zM54.8 66v25.5c0 2.9 2.3 5.2 5.2 5.2h17c2.9 0 5.2-2.3 5.2-5.2V74.6c0-2.9-2.3-5.2-5.2-5.2H65.2V66c0-6.4 5.3-11.7 11.8-11.7 2.9 0 5.2-2.3 5.2-5.2 0-2.9-2.3-5.2-5.2-5.2-12.3 0-22.2 10-22.2 22.1zm47.5 0v25.5c0 2.9 2.3 5.2 5.2 5.2h17.1c2.9 0 5.2-2.3 5.2-5.2V74.6c0-2.9-2.3-5.2-5.2-5.2h-11.9V66c0-6.4 5.3-11.7 11.9-11.7 2.9 0 5.2-2.3 5.2-5.2 0-2.9-2.3-5.2-5.2-5.2-12.3 0-22.3 10-22.3 22.1z"
          fill="#1f1f1f"
        />
        <path
          d="M56.9 0C25.5 0 0 25.4 0 56.5v70.2c0 31.1 25.5 56.5 56.9 56.5h47.9l-31.6-22.6H56.9c-18.8 0-34.2-15.2-34.2-33.9V56.5c0-18.7 15.3-33.9 34.2-33.9h70.7c18.8 0 34.2 15.2 34.2 33.9v70.2c0 18.7-15.3 33.9-34.2 33.9h-13.4v22.6h13.4c31.4 0 56.9-25.4 56.9-56.5V56.5C184.6 25.4 159 0 127.6 0H56.9z"
          fill="#ff5551"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgKustomer);
